module.exports = __webpack_public_path__ + "img/JP.71e92914.gif";